module.exports = __webpack_public_path__ + "static/media/dmitry.a4330862.png";